import config from '../const'
export default {
    computed: {
        vue_node_env: function(){
            return process.env.NODE_ENV;
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
        cHeader: function(){
            return {headers: this.axiosHeader}; 
        },
        get_now_date_num: function(){
            var date = new Date()
            return parseInt(date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2));
        },
        vue_lodge_oneyear_sp_term: function(){
            if(
                this.get_now_date_num <= 20241231
            ){
                return (this.vue_node_env == 'production')? false: true;
            }
            else{
                return false;
            }
        }
    },
    methods: {
        number_format(value){
            return value.toString().replace(
                /(\d+?)(?=(?:\d{3})+$)/g,
                function (x) {
                    return x + ',';
                }
            );
        },
        is_json(value){
            try {
                JSON.parse(value);
            } catch (error) {
                return false;
            }
            return true;
        },
        setParams(params, mode){
            const params_ = new URLSearchParams();
            if(params){
                const keys = Object.keys(params);
                for(let i=0; i < keys.length; i++){
                    if(keys[i] == 'p'){
                        params_.append(keys[i], params[keys[i]]);
                    }
                    else if(params[keys[i]] !== null && typeof params[keys[i]] === 'object'){
                        params_.append(mode + '[' + keys[i] + ']', JSON.stringify(params[keys[i]]));
                    }
                    else{
                        params_.append(mode + '[' + keys[i] + ']', params[keys[i]]);
                    }
                }
            }
            return params_;
        },
        setParams_S(params){
            return this.setParams(params, 'sprm');
        },
        setParams_I(params){
            return this.setParams(params, 'iprm');
        },

    }
}
